// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
mobile-app-promotion .contentWrapper {
  text-align: center;
}
mobile-app-promotion .contentWrapper .textCircle {
  background-color: var(--c_mainColorDark);
  border-radius: 100%;
  font-size: 0.875em;
  line-height: 1.2em;
  padding: 50% 10% 50%;
  color: #fff;
  text-align: center;
  margin-bottom: 6px;
}
mobile-app-promotion .contentWrapper .textCircle .textHolder {
  height: 0px;
}
mobile-app-promotion .contentWrapper .textCircle .textHolder .text {
  transform: translateY(-50%);
}
mobile-app-promotion .contentWrapper img {
  margin: 5px 0px 0px;
  width: 100%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
